import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../diccionarios/comisionesModulo';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CarteraCargasUploadCsvService {

  diccionarioUrl: any;
  urlMaestros: string;
  urlComisiones: string;
  constructor(
    private commom: CommonService,
    private utilServices: UtilsService
  ) {
    this.urlMaestros = this.utilServices.getDatosMaestros();
    this.urlComisiones = this.utilServices.getComisiones();
    this.diccionarioUrl = comisionesModulo.url.cargaCarteras;
  }

  getTodo() {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.getTodo);
  }  
  
  procesarCsv(formData: FormData, anio, tipocarga): Observable<any[]> {
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.recepcionCsv + "anio=" + anio + "&tipoCarga=" + tipocarga, formData);
  }

  saveCsv(listObj: any[]) { //
    console.log("saveCsvIndicadores", listObj)
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.recepcionCsvSave , listObj);
  }

}
